import css from 'styled-jsx/css';

const styles = css.global`header {
    background: #FFF;
    height: 80px;
    display: flex;
    align-items: center;
}

header .ctn-home-24 {
    display: flex;
    justify-content: center;
}

@media (min-width: 992px) {
    header .ctn-home-24 {
        justify-content: flex-start;
    }
}`;

export default styles;